/* Presentation only. Never changes price, cart quantities, variant IDs or discounts. */
(function(){
 function init(){
  document.querySelectorAll('main variant-selects').forEach(function(picker){
   if(picker.dataset.mfStyled)return;
   var fieldsets=[].slice.call(picker.querySelectorAll('.product-form__input--pill'));
   var pack=fieldsets.find(function(el){return /pack|kit|oferta|cantidad|bundle|elige/i.test(el.querySelector('legend')?.textContent||'')})||fieldsets.find(function(el){return el.querySelectorAll('input[type=radio]').length>=2});
   if(!pack)return;
   picker.dataset.mfStyled='true';picker.classList.add('mf-pack-enhanced');
   var inputs=[].slice.call(pack.querySelectorAll('input[type=radio]'));
   // Show only gifts already explicitly named in the actual option labels; never invent promotions.
   var gifts=[];
   inputs.forEach(function(input){var label=pack.querySelector('label[for="'+CSS.escape(input.id)+'"]');var name=(label?.textContent||'').trim().replace(/\s+/g,' ');var match=name.match(/(?:regalo|gratis|gift|free)[^,|•;]*/ig);if(match)match.forEach(function(g){g=g.trim();if(g&&!gifts.includes(g))gifts.push(g)})});
   if(!gifts.length)return;
   var panel=document.createElement('div');panel.className='mf-pack-unlocks';panel.setAttribute('aria-live','polite');
   panel.innerHTML='<div class="mf-pack-unlocks__heading">🎁 Regalos de tu pack</div><div class="mf-pack-unlocks__items"></div>';
   pack.insertAdjacentElement('afterend',panel);
   var holder=panel.querySelector('.mf-pack-unlocks__items');
   function refresh(){
    var active=inputs.find(function(i){return i.checked});
    var label=active&&pack.querySelector('label[for="'+CSS.escape(active.id)+'"]');
    var selected=(label?.textContent||'').toLowerCase();
    holder.replaceChildren();
    gifts.forEach(function(g){var unlocked=selected.includes(g.toLowerCase());var row=document.createElement('div');row.className='mf-pack-unlocks__gift';row.dataset.active=String(unlocked);
      var ico=document.createElement('span');ico.className='mf-pack-unlocks__icon';ico.textContent=unlocked?'🎁':'🔒';
      var detail=document.createElement('span');var name=document.createElement('div');name.className='mf-pack-unlocks__name';name.textContent=g;
      var status=document.createElement('div');status.className='mf-pack-unlocks__status';status.textContent=unlocked?'Incluido en tu selección':'Disponible en otro pack';
      detail.append(name,status);row.append(ico,detail);holder.append(row);
    });
   }
   picker.addEventListener('change',refresh);refresh();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
